<template>
    <div class="wui-container house-list">
        <div class="header">
            <div class="header-item" :class="{'header-item-active': filterIndex == 1}" @click="setFilter(1)">
                <span>{{$t('位置')}}</span>
                <i class="iconfont icon-trigon"></i>
            </div>
            <div class="header-item" :class="{'header-item-active': filterIndex == 2}" @click="setFilter(2)">
                <span>{{$t('租房类型')}}</span>
                <i class="iconfont icon-trigon"></i>
            </div>
            <div class="header-item" :class="{'header-item-active': filterIndex == 3}" @click="setFilter(3)">
                <span>{{$t('价格')}}</span>
                <i class="iconfont icon-trigon"></i>
            </div>
        </div>

        <div class="position" v-if="filterIndex">
            <div class="position-wrapper" @click="closeFilter"></div>
            <div class="position-list">
                <div class="position-list-top" v-if="filterIndex != 3">
                    <div class="position-left">
                        <div v-if="filterIndex == 1">
                            <div class="left-nav"
                                :class="{'position-left-txt-active': filterType == 'district', 'position-left-txt': filterType != 'district'}"
                                @click="filterFirst('district')">{{$t('区域')}}</div>
                            <div class="left-nav"
                                :class="{'position-left-txt-active': filterType == 'subway', 'position-left-txt': filterType != 'subway'}"
                                @click="filterFirst('subway')">{{$t('地铁')}}</div>
                        </div>
                        <div v-if="filterIndex == 2">
                            <div class="left-nav"
                                :class="{'position-left-txt-active': filterType == 'time', 'position-left-txt': filterType != 'time'}"
                                @click="filterFirst('time')">{{$t('租期')}}</div>
                            <div class="left-nav"
                                :class="{'position-left-txt-active': filterType == 'type', 'position-left-txt': filterType != 'type'}"
                                @click="filterFirst('type')">{{$t('类型')}}</div>
                        </div>
                    </div>
                    <div class="position-right">
                        <div class="position-right-item" 
                            v-for="(item, index) in filterList" 
                            :key="item.id" 
                            @click="filterSecond(item.id, index)">
                            <div :class="{'position-right-txt-active': item.isChecked, 'position-right-txt': !item.isChecked}">{{item.name}}</div>
                            <div class="position-right-item-img" v-if="item.isChecked">
                                <img src="https://qnimg.wellcee.com/Checkmark@3x.png">
                            </div>
                        </div>
                    </div>
                </div>
        
                <div class="price-list" v-if="filterIndex == 3">
                    <div class="price-item" 
                        v-for="(item, index) in filterList" 
                        :key="item.id" 
                        @click="filterSecond(item.id, index)">
                        <div v-if="item.id == 0"
                            :class="{'price-txt-active': item.isChecked, 'price-txt': !item.isChecked}">{{item.name}}</div>
                        <div v-if="item.id != 0"
                            :class="{'price-txt-active': item.isChecked, 'price-txt': !item.isChecked}">
                            {{item.minPrice == item.maxPrice ? item.maxPrice + '+' : item.minPrice + '-' + item.maxPrice}}
                        </div>
                    </div>
                </div>
                <div class="position-btn" @click="filter">
                    <div class="position-btn-txt">{{$t('确定')}}</div>
                </div>
            </div>
        </div>

        <!-- 列表 -->
        <van-list
            v-model:loading="loading"
            :finished="finished"
            :loading-text="$t('加载中')"
            @load="onLoad"
        >
            <div class="list">
                <div class="house-item" v-for="item in list" :key="item.id">
                    <router-link :to="`/rent-apartment/${item.id}`">
                        <div class="baseinfo">
                            <div class="heading">
                                <img :src="util.thumb(item.userInfo.avatar, 120)">
                            </div>
                            <div class="other">
                                <div class="other-top">
                                    <div class="other-top-left">
                                        <span class="name">{{item.userInfo.name}}</span>
                                        <i class="iconfont icon-woman1" v-if="item.userInfo.gender == 2"></i>
                                        <i class="iconfont icon-man" v-if="item.userInfo.gender == 1"></i>
                                    </div>
                                    <div class="login-time">{{$t('最后登录')}}</div>
                                </div>
                                <div class="other-bottom">
                                    <text class="other-bottom-left">{{util.join(item.userInfo.languages, ' · ')}}</text>
                                    <text class="other-bottom-right">{{item.userInfo.loginTime}}</text>
                                </div>
                            </div>
                        </div>
                        
                        <div class="house-imgs">
                            <div class="house-img" v-for="(img, index) in item.imgs" :key="index">
                                <img class="img" :src="util.thumb(img, 345, 240)">
                                <img class="video" v-if="index == 0 && item.video" src="@/assets/img/icon-video.png">
                            </div>
                            <CollectNumber 
                                :objId="item.id"
                                :type=1
                                :number="item.collectCount"
                                :isCollect="item.isCollect"></CollectNumber>
                        </div>
                        <div class="house-info">
                            <span class="house-price">{{item.rent}}</span>
                            <div class="house-tag" v-for="(item, index) in item.tags" :key="index">{{item}}</div>
                        </div>
                        <div class="house-address">{{item.address}}</div>
                    </router-link>
                </div>
            </div>
        </van-list>

        <HomeButton></HomeButton>
    </div>
</template>

<script>
import { useRoute } from "vue-router";
import { List } from 'vant';

import api from "@/api/index";
import CollectNumber from "@/components/CollectNumber.vue";
import HomeButton from "@/components/HomeButton.vue";
import { initWechatJSSDK } from "@/assets/wechat.js"

export default {
    components: {
        VanList: List,
        CollectNumber,
        HomeButton,
    },
    data() {
        return {
            filterIndex: 0,
            filterType: '',
            filterData: {},
            filterDataItem: {},
            filterList: {},

            cityId: '',
            query: {},
            pn: 0,
            ps: 20,
            loading: false,
            finished: false,
            list: [],
        };
    },
    mounted() {
        const route = useRoute();
        this.cityId = route.query.cityId;
        this.query = route.query;

        this.getShareInfo();
    },
    activated() {
        const route = useRoute();
        if (this.cityId != route.query.cityId) {
            this.cityId = route.query.cityId;
            this.query = route.query;
            this.pn = 0;
            this.ps = 20;
            this.loading = true;
            this.finished = false;
            this.list = [];
            this.getShareInfo();
            this.onLoad();
        }
    },
    methods: {
        // 加载
        onLoad(){
            if (this.finished) {
                return false;
            }
            this.pn++;
            if (this.pn == 1) {
                this.getFilterType();
            }else{
                this.getHouseList();
            }
        },
        // 刷新
        onRefresh(){
            this.pn = 1;
            this.loading = true;
            this.finished = false;
            this.list = [];
            this.getHouseList();
        },
        // 获取房源列表
        getHouseList(){
            let params = {
                lang: this.util.language(),
                pageNum: this.pn,
                cityId: this.cityId,
                districtIds: [],
                subways: [],
                rentTypeIds: [],
                timeTypeIds: [],
                price: []
            };
            if (!this.filterData.position) {
                return false;
            }
            this.filterData.position.district.forEach((item)=>{
                if (item.isChecked && item.id !== 0) {
                    params.districtIds.push(item.id)
                }
            });
            this.filterData.position.subway.forEach((item)=>{
                if (item.isChecked && item.id !== 0) {
                    params.subways.push(item.id)
                }
            });
            this.filterData.houseType.type.forEach((item)=>{
                if (item.isChecked && item.id !== 0) {
                    params.rentTypeIds.push(item.id)
                }
            });
            this.filterData.houseType.time.forEach((item)=>{
                if (item.isChecked && item.id !== 0) {
                    params.timeTypeIds.push(item.id)
                }
            });
            this.filterData.price.forEach((item)=>{
                if (item.isChecked && item.id !== 0) {
                    params.price.push({
                        'id': item.id,
                        'minPrice': Number(item.minPrice),
                        'maxPrice': Number(item.maxPrice)
                    });
                }
            });
            api.house.get(params).then(res => {
                let data = res.data.list;
                data.forEach((item)=>{
                    item.imgs = item.imgs.splice(0, 3);
                    if (item.dailyRent) {
                        item.tags.push(item.dailyRent);
                    }
                })
                
                if (data.length < this.ps) {
                    this.finished = true;
                }
                
                this.list = this.list.concat(data);
                this.loading = false;
            });
        },
        // 获取筛选项
        getFilterType(){
            api.house.filterType({
                cityId: this.cityId,
                lang: this.util.language(),
            }).then((res)=>{
                let data = res.data;
                const getHash = this.util.getHashParam;

                // 兼容获取参数：优先从 this.query 取，没有再从 hash 取
                const getVal = (key) => this.query[key] || (getHash && getHash(key));
                // 转换参数数组，同时存入字符串和数字，避免后续 indexOf 严格类型匹配失败
                const parseIds = (key) => {
                    let vals = getVal(key) ? String(getVal(key)).split('_') : [];
                    return vals.concat(vals.map(v => Number(v)));
                };

                const districtIds = parseIds('districtIds');
                const subways = parseIds('subways');
                const rentTypeIds = parseIds('rentTypeIds');
                const timeTypeIds = parseIds('timeTypeIds');
                const price = parseIds('price');

                data.district.forEach((item)=>{
                    if (districtIds.indexOf(item.id) > -1) {
                        item.isChecked = true;
                    } else {
                        item.isChecked = false;
                    }
                });
                data.district.unshift({
                    id: 0,
                    name: this.$t('全部'),
                    isChecked: (districtIds.length > 0 ? false : true)
                });

                data.subway.forEach((item)=>{
                    if (subways.indexOf(item.id) > -1) {
                        item.isChecked = true;
                    } else {
                        item.isChecked = false;
                    }
                });
                data.subway.unshift({
                    id: 0,
                    name: this.$t('全部'),
                    isChecked: (subways.length > 0 ? false : true)
                });

                data.type.forEach((item)=>{
                    if (rentTypeIds.indexOf(item.id) > -1) {
                        item.isChecked = true;
                    } else {
                        item.isChecked = false;
                    }
                });
                data.type.unshift({
                    id: 0,
                    name: this.$t('全部'),
                    isChecked: (rentTypeIds.length > 0 ? false : true)
                });

                data.time.forEach((item)=>{
                    if (timeTypeIds.indexOf(item.id) > -1) {
                        item.isChecked = true;
                    } else {
                        item.isChecked = false;
                    }
                });
                data.time.unshift({
                    id: 0,
                    name: this.$t('全部'),
                    isChecked: (timeTypeIds.length > 0 ? false : true)
                });

                let isPriceChecked = false;
                const queryPriceId = getVal('priceId');
                data.price.forEach((item)=>{
                    // 兼容通过 priceId 匹配，或者通过原有的 minPrice / maxPrice 匹配
                    if ((queryPriceId && item.id == queryPriceId) || 
                        (!queryPriceId && item.minPrice == getVal('minPrice') && item.maxPrice == getVal('maxPrice'))) {
                        isPriceChecked = true;
                        item.isChecked = true;
                    }else{
                        item.isChecked = false;
                    }
                });
                data.price.unshift({
                    id: 0,
                    name: this.$t('全部'),
                    isChecked: (isPriceChecked ? false : true)
                });

                this.filterList = data;
                this.filterData = {
                    position: {
                        district: data.district,
                        subway: data.subway
                    },
                    houseType: {
                        type: data.type,
                        time: data.time
                    },
                    price: data.price
                }
                this.getHouseList();
            })
        },
        // 设置筛选项
        setFilter(index){
            if (index == 1) {
                this.filterDataItem = this.filterData.position;
                this.filterType = 'district';
                this.filterList = this.filterData.position['district'];
            } else if (index == 2) {
                this.filterDataItem = this.filterData.houseType;
                this.filterType = 'time';
                this.filterList = this.filterData.houseType['time'];
            } else if (index == 3) {
                this.filterList = this.filterData.price;
            }

            if (this.filterIndex === index) {
                return;
            }
            this.filterIndex = index;
        },
        filter(){
            this.filterIndex = 0;
            this.onRefresh();
        },
        // 关闭筛选
        closeFilter(){
            this.filterIndex = 0;
        },
        filterFirst(type){
            this.filterList = this.filterDataItem[type];
            this.filterType = type;

            // 城区 地铁 二选一
            if (type === 'subway') {
                this.filterData.position.district.forEach((item)=>{
                    if (item.id == 0) {
                        item.isChecked = true;
                    }else{
                        item.isChecked = false;
                    }
                });
            }else {
                this.filterData.position.subway.forEach((item)=>{
                    if (item.id == 0) {
                        item.isChecked = true;
                    }else{
                        item.isChecked = false;
                    }
                });
            }
            
        },
        filterSecond(id, index){
            if (id == 0) {
                this.filterList.forEach((item)=>{
                    if (item.id == 0) {
                        item.isChecked = true;
                    }else{
                        item.isChecked = false;
                    }
                });
            } else {
                this.filterList.forEach((item) => {
                    if (item.id == id) {
                        item.isChecked = !item.isChecked;
                    }
                });

                let isHasChecked = false;
                this.filterList.forEach((item)=>{
                    if (item.isChecked) {
                        isHasChecked = true;
                    }
                });
                if (isHasChecked) {
                    this.filterList[0].isChecked = false;
                } else {
                    this.filterList[0].isChecked = true;
                }
            }
        },
        // 获取分享数据
        getShareInfo(){
            api.common.getShareInfo({
                cityId: this.cityId,
                type: 2, // 1 城市攻略 2 房源列表 3 二手物品
            }).then((res)=>{
                initWechatJSSDK({
                    title: res.data.title,
                    desc: res.data.content,
                    imgUrl: res.data.img
                });
            })
        }
    },
};
</script>

<style scoped>

.header {
    position: fixed;
    width: 100%;
    top: 0;
    z-index: 100;
    max-width: 500px;
    display: flex;
    align-items: center;
    height: 50px;
    background-color: #fff;
    box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.03);
}
.header .header-item {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    font-size: 15px;
    color: #111111;
}
.header .header-item .icon-trigon{
    color: #A3B1C1;
    font-size: 6px;
    margin-left: 4px;
}
.header .header-item-active {
    color: #2DB6B4;
}


.position {
    position: fixed;
    top: 50px;
    z-index: 100;
    max-width: 500px;
    width: 100%;
    margin: 0 auto;
    height: 100%;
    border-top: 1px solid #f8f8f8;
}
.position .position-wrapper{
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background-color: rgba(0, 0, 0, .6);
    z-index: 100;
}
.position .position-list {
    position: relative;
    z-index: 101;
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 380px;
    background-color: #fff;
}
.position .position-list-top {
    display: flex;
    flex-direction: row;
    width: 100%;
    background-color: #fff;
}
.position .position-left {
    flex: 1;
    flex-direction: column;
    height: 310px;
    background-color: #fff;
}
.position .position-left .left-nav {
    display: block;
    width: 100%;
    height: 70px;
    text-align: center;
    line-height: 70px;
}
.position .position-right {
    height: 310px;
    flex: 1;
    background-color: #F5F6F7;
    overflow-y: auto;
    -webkit-overflow-y: auto;
    -moz-overflow-y: auto;
}
.position .position-right .position-right-item {
    position: relative;
    display: block;
    width: 100%;
    height: 44px;
    line-height: 44px;
    text-align: center;
}
.position .position-left-txt-active {
    font-size: 15px;
    color: #2DB6B5;
}
.position .position-left-txt {
    font-size: 15px;
    color: #111;
}
.position .position-right-item-img {
    position: absolute;
    top: 0;
    right: 10%;
    width: 13px;
    height: 10px;
}
.position .position-right-item-img img{
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.position .position-btn {
    box-sizing: border-box;
    width: 100%;
    height: 70px;
    padding: 12px;
    background-color: #fff;
    text-align: center;
}
.position .position-btn div {
    display: block;
    width: 100%;
    height: 46px;
    background-color: #2DB6B5;
    border-radius: 3px;
    color: #fff;
    line-height: 46px;
    margin: 0 auto;
}
.position .price-list {
    width: 100%;
}
.position .price-list .price-item {
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-align: center;
}
.position .price-txt-active {
    font-size: 14px;
    color: #2DB6B5;
}
.position .price-txt {
    font-size: 14px;
    color: #111;
}

.list {
    padding-top: 50px;
}
.list .house-item {
    background-color: #fff;
    margin-bottom: 10px;
    border-radius: 15px;
    overflow: hidden;
}
.list .house-item a{
    display: inline-block;
    padding: 17px 15px 15px 15px;
}
.list .house-item .baseinfo {
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: center;
}
.list .house-item .heading {
    width: 44px;
    min-width: 44px;
    height: 44px;
    margin-right: 10px;
}
.list .house-item .heading img {
    height: 100%;
    width: 100%;
    object-fit: cover;
    border-radius: 2px;
}
.list .house-item .baseinfo .iconfont{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 2px;
    height: 20px;
    width: 24px;
    border-radius: 6px;
    color: #111;
    background: rgba(17, 17, 17, 0.03);
}
.list .house-item .other {
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: space-between;
}
.list .house-item .other-top {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 2px;
}
.list .house-item .other-top-left{
    display:flex;
    align-items: center;
}
.list .house-item .name{
    font-weight: 500;
    font-size: 18px;
    line-height: 25px;
    color: #111111;
    max-width: 180px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.list .house-item .login-time {
    font-size: 12px;
    color: #666666;
}
.list .house-item .other-bottom {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    color: #666666;
}
.list .house-item .other-bottom-left {
    flex: 1;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}



.list .house-item .house-imgs {
    position: relative;
    display: flex;
    margin-top: 13px;
    margin-bottom: 8px;
}
.list .house-item .house-img {
    position: relative;
    width: 33.33%;
    height: 88px;
    margin-right: 1px;
}

.list .house-item .house-img .img {
    width: 100%;
    height: 100%;
}
.list .house-item .house-img .video{
    position: absolute;
    bottom: 10px;
    right: 10px;
    width: 14px;
    height: 14px;
}
.list .house-item .house-info {
    display: flex;
    flex-wrap: wrap;
    max-height: 54px;
    overflow: hidden;
}
.list .house-item .house-info .house-price {
    display: flex;
    align-items: center;
    height: 23px;
    font-size: 14px;
    color: #2DB6B4;
    margin-right: 8px;
}
.list .house-item .house-info .house-tag {
    display: inline-block;
    box-sizing: border-box;
    padding: 0 7px;
    height: 23px;
    line-height: 21px;
    border-radius: 6px;
    border: 1px solid rgba(17, 17, 17, 0.03);
    font-size: 12px;
    color: #666;
    margin-right: 8px;
    margin-bottom: 4px;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.list .house-item .house-address {
    margin-top: 2px;
    font-size: 15px;
    line-height: 21px;
    color: #111111;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
